import React, { Component } from "react";
import Chart from "react-apexcharts";
import Label from "src/views/dashboard/lavel_icon";
import Value from "src/views/dashboard/Value_icon";
class MultiAxix extends Component {
  constructor(props) {
    super(props);
    this.Legend = this.Legend.bind(this);   
    this.dataLabels = this.dataLabels.bind(this);  
    this.updateCharts = this.updateCharts.bind(this);

   
    if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
      this.state = {
          
        series: this.props.prams.filterData[this.props.prams.prams.kpiId]['series'],
        options: {
          Chart:{
            type:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['type']
          },
          dataLabels: {
            enabled:false,
            style: {
              fontSize: '14px',   
              fontWeight: 500,
              fontFamily:'gadugi',           
            }
        
          },
          legend: {
            show: false,
            fontSize: '14px',
            fontFamily:'gadugi',   
          },
          plotOptions:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['plotOptions'],
          xaxis:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['xaxis'],
          yaxis:this.props.prams.filterData[this.props.prams.prams.kpiId]['options']['yaxis'],
        },
      
      
      };
    };
   
  }
   componentDidUpdate(prevProps){
    
    if (this.props.prams.legend !== prevProps.prams.legend) {
      if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
         this.updateCharts();
      }
    }
   }

   
  updateCharts() {
    this.setState({
      options:{
         legend: {
          show: this.props.prams.legend
        }
      },
    });
  }
  Legend() {
    this.setState(prevState => ({
      options: {
        ...prevState.options,
        legend: {
          ...prevState.options.legend,
          show: !prevState.options.legend.show
        }
      }
    }));
    const { options } = this.state;
    const fill = options.legend.show ? 'green' : 'red';
  }
  

  dataLabels(){   
    console.log(this.state);
    this.setState(prevState => ({
        options: {
          ...prevState.options,
          dataLabels: {
            ...prevState.options.dataLabels,
            enabled:!this.state.options.dataLabels.enabled
          }
        }
      }));
    }
  
  render() {
    if(this.props.prams.filterData[this.props.prams.prams.kpiId]!=undefined){
      return (
        <div className='Polar'>
          <div className='row'>
            <div className='col-lg-10'>
              <div className='componentNameC'>{this.props.prams.prams.component}</div>
            </div>
            <div className='col-lg-2 '>
            <div class="btn-group component_action_button" role="group" aria-label="Basic example">
            <div onClick={this.dataLabels}  style={{ marginRight: '5px' }}>
                <Value show={this.state.options.dataLabels.enabled}/>
            </div>
                <div onClick={this.Legend}  >
                  <Label show={this.state.options.legend.show}/>
                </div>
                
              </div>
            </div>
          </div>
          <div className="p-4 Polar1" style={{paddingBottom:'3px'}}>
            <Chart
                options={this.state.options}
                series={this.state.series}
                height='100%'
                type="line"  />
              
          </div>
        </div>
      );
  }else{
  return (
    <div className='Polar'>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='componentNameC'>{this.props.prams.prams.component}</div>
        </div>
      </div>
      <div className="p-2 Polar1" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh', // Optionally set a height to center vertically in the viewport
        color: '#85929E'
      }}>
        Data Not Found!
      </div>

    </div>
  );
 }
}
}

export default MultiAxix;
